import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as SearchIcon } from "Assets/svg/search.svg";

const SearchInputByKeyword = props => {
  const {
    id = "",
    placeholder = "Search here",
    handleSearch = () => {},
    debounce = 0,
    initialValue = ""
  } = props || {};

  const [searchKeyword, setSearchKeyword] = useState(initialValue);
  const [showClose, setShowClose] = useState(!!initialValue);
  const timerRef = useRef(null);

  const fireSearch = value => {
    if (debounce > 0) {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => handleSearch(value), debounce);
    } else {
      handleSearch(value);
    }
  };

  const handleChange = e => {
    let value = e.currentTarget.value;
    setSearchKeyword(value);
    setShowClose(value ? true : false);
    fireSearch(value?.trim());
  };

  const resetState = () => {
    setSearchKeyword("");
    setShowClose(false);
  };

  const clearSearch = () => {
    clearTimeout(timerRef.current);
    resetState();
    handleSearch("");
  };

  useEffect(() => {
    setSearchKeyword(initialValue);
    setShowClose(!!initialValue);
  }, [initialValue]);

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current);
      resetState();
    };
  }, []);

  return (
    <div className={`searchWrapper ${id}`} id={id}>
      <div className="searchInput">
        <span className="searchImage">
          <SearchIcon />
        </span>
        <span className="searchTextBox">
          <input
            name="search"
            id="searchEmailContact"
            autoComplete="off"
            value={searchKeyword}
            type="text"
            placeholder={placeholder}
            onChange={e => handleChange(e)}
            autoFocus={true}
            required
          />
          {showClose && (
            <i className="material-icons" onClick={clearSearch}>
              close
            </i>
          )}
        </span>
      </div>
    </div>
  );
};

export default SearchInputByKeyword;
export { SearchInputByKeyword };
